module.exports = __webpack_public_path__ + "static/img/fullBody4.59b1b404.png";